import { useEffect } from "react";
import "../styles/Contents.css";

export default function StayStudyPage({
  className,
  heroTitle,
  heroDescription,
  section1,
  section2,
  whyUs,
  images,
  fee,
  whatsappText
}) {
  useEffect(() => {
    const elements = document.querySelectorAll(
      ".reveal, .reveal-left, .reveal-right"
    );
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) =>
          entry.isIntersecting
            ? entry.target.classList.add("active")
            : entry.target.classList.remove("active")
        );
      },
      { threshold: 0.15 }
    );
    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="page">
      {/* HERO */}
      <section className="about-hero reveal">
        <h1>{heroTitle}</h1>
        <p>{heroDescription}</p>
      </section>

      {/* SECTION 1 */}
      <section className="about-section reveal-left">
        <div className="about-row">
          <div className="about-content">
            <h2>{section1.title}</h2>
            <p>{section1.description}</p>
            <ul>
              {section1.points.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>
          <img src={images.section1} className="about-image" alt="Students studying together" />
        </div>
      </section>

      {/* SECTION 2 */}
      <section className="about-section reveal-right">
        <div className="about-row reverse">
          <div className="about-content">
            <h2>{section2.title}</h2>
            <p>{section2.description}</p>
            <ul>
              {section2.points.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>
          <img src={images.section2} className="about-image"  alt="Students studying together"/>
        </div>
      </section>

      {/* WHY US */}
      <section className="about-section reveal-left">
        <div className="about-row">
          <div className="about-content">
            <h2>{whyUs.title}</h2>
            <p>{whyUs.description}</p>
            <ul>
              {whyUs.points.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>
          <img src={images.whyUs} className="about-image" alt="Students studying together" />
        </div>
      </section>

      {/* FEES CARD */}
      <section className="about-section reveal">
        <div className="fees-card-wrapper">
          <div className="fees-card">
            <span className="fees-badge">{className}</span>

            <h2 className="fees-title">Stay & Study Program</h2>

            <div className="fees-amount">
              <span className="currency">₹</span>{fee}
            </div>

            <p className="fees-duration">Per Academic Year</p>

            <ul className="fees-details">
              <li>✔ Fully residential hostel accommodation</li>
              <li>✔ Nutritious and hygienic daily meals</li>
              <li>✔ Supervised study hours with mentors</li>
              <li>✔ Concept-based learning approach</li>
              <li>✔ Regular assessments & feedback</li>
              <li>✔ Safe and disciplined campus</li>
            </ul>

            <a
              href={`https://wa.me/919964585585?text=${encodeURIComponent(
                whatsappText
              )}`}
              target="_blank"
              rel="noreferrer"
            >
              <button className="fees-cta whatsapp-btn">
                <span className="wa-icon">💬</span>
                Enquire Now
              </button>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
